import { useState } from 'react'
import { ChatMessage } from '@portfolio/shared'
import HeroSection from './components/HeroSection'
import ChatSection from './components/ChatSection'

function App() {
  const [messages, setMessages] = useState<ChatMessage[]>([])
  const [isLoading, setIsLoading] = useState(false)

  const handleSendMessage = async (message: string) => {
    const userMessage: ChatMessage = {
      id: Date.now().toString(),
      type: 'user',
      content: message,
      timestamp: new Date(),
    }

    setMessages(prev => [...prev, userMessage])
    setIsLoading(true)

    try {
      const response = await fetch(`${import.meta.env.VITE_WORKER_URL}/chat`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          message,
          sessionId: 'portfolio-session',
        }),
      })

      if (!response.ok) {
        throw new Error('Failed to send message')
      }

      const data = await response.json()

      const assistantMessage: ChatMessage = {
        id: (Date.now() + 1).toString(),
        type: 'assistant',
        content: data.response,
        timestamp: new Date(),
        confidence: data.confidence,
        sources: data.sources,
      }

      setMessages(prev => [...prev, assistantMessage])
    } catch (error) {
      console.error('Error sending message:', error)
      
      const errorMessage: ChatMessage = {
        id: (Date.now() + 1).toString(),
        type: 'assistant',
        content: '申し訳ございませんが、エラーが発生しました。しばらくしてからもう一度お試しください。',
        timestamp: new Date(),
        confidence: 'low',
      }

      setMessages(prev => [...prev, errorMessage])
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="min-h-screen bg-black relative overflow-hidden">
      {/* Base gradient background with color shifting */}
      <div className="absolute inset-0 animate-bg-shift" />
      
      {/* Multiple animated gradient overlays with black base */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-tr from-black via-gray-900 to-blue-900/40 animate-color-shift" />
        <div className="absolute inset-0 bg-gradient-to-bl from-black via-gray-800 to-purple-900/30 animate-color-shift-delayed" />
        <div className="absolute inset-0 bg-gradient-to-br from-black via-gray-900 to-indigo-900/25 animate-color-shift-delayed-2" />
        <div className="absolute inset-0 bg-gradient-to-tl from-black via-gray-800 to-violet-900/20 animate-hue-rotate" />
      </div>
      
      
      <div className="relative z-10 max-w-4xl mx-auto px-4 py-4 sm:py-6 md:py-8">
        <div className="glass-panel p-4 sm:p-6 md:p-8 animate-fade-in">
          <HeroSection />
          <ChatSection 
            messages={messages}
            onSendMessage={handleSendMessage}
            isLoading={isLoading}
          />
        </div>
      </div>
    </div>
  )
}

export default App